import React, { useState } from 'react'
import './toolbar.scss'

const Toolbar = ({
  menus = [],
  searchFunc = term => console.log({ term })
}) => {
  const [searchTerm, setSearchTerm] = useState('')

  const renderMenus = () => {
    const dropdowns = []
    for (let i = 0; i < menus.length; ++i) {
      const { name, options, func, selected } = menus[i]
      const optionDivs = []
      for (let j = 0; j < options.length; ++j) {
        const _option = options[j]
        optionDivs.push(
          <a
            key={'toolbar:' + i + ':' + j}
            onClick={() => func(_option)}
            className={_option === selected ? 'selected' : ''}>
            {_option}
          </a>
        )
      }

      dropdowns.push(
        <div className="dropdown" key={'dropdown:' + i}>
          <div className="dropbtn">{name}</div>
          <div className="dropdown-content">{optionDivs}</div>
        </div>
      )
    }

    return dropdowns
  }

  const handleSearchChange = e => {
    const { value } = e.target
    setSearchTerm(value)
    searchFunc(value)
  }

  return (
    <div className="toolbar">
      {renderMenus()}
      <div className="toolbar-search">
        <span>Search: </span>
        <input type="text" onChange={handleSearchChange} value={searchTerm} />
      </div>
    </div>
  )
}

export default Toolbar
